import { render, staticRenderFns } from "./msg-manager.vue?vue&type=template&id=135ec73f&lang=pug&"
import script from "./msg-manager.vue?vue&type=script&lang=js&"
export * from "./msg-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports